export default __webpack_public_path__ + "static/worldmap-bdaf0036b05a732f244a2b3d8931d095.svg";